import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header_container" }
const _hoisted_2 = { class: "header_container" }
const _hoisted_3 = { class: "header_container" }
const _hoisted_4 = {
  key: 2,
  class: "pl-2"
}
const _hoisted_5 = {
  key: 3,
  class: "pl-3"
}

import { ref, Ref, onMounted, watch, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { LABELS } from '@/constants/labels';

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getVirMacServerByIP } from '@/services/Smartlink/Server';
import { VIRMAC } from '@/interfaces/SmartLink/Server';
import { HEADER } from '@/interfaces/SmartLink/Tables';


export default /*@__PURE__*/_defineComponent({
  __name: 'VirMacDialog',
  props: {
    ip          : { required:true, type:Array<string> },
    rows        : { required:true, type:Number },
    recharge    : { required:true, type:Boolean },
    emited      : { required:true, type:Boolean },
},
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const props = __props


/**
 * Del Dashboard cuando recargas los datos cada 15 minutos o dandole
 * al botón de recarga
 */
const isRecharge                = computed(() => props.recharge);

/**
 * Si la consulta a la API, tiene valores
 */
const isDataLength              = ref(true);

/**
 * Array de IPs que vienen del padre, mayormente del Dashboard
 */
const computeipsArray           = computed(() => props.ip)

/**
 * Copia de computeipsArray, con el propósito de que se modifique
 */
const ipsArray                  = ref(computeipsArray.value)

const finalTableItems:Ref<VIRMAC[]>     = ref([]);

/**
 * Captura los valores de la API: "getVirMacServer"
 * mandando como parámetro la IP del servidor 
 */
const getMVSDialog = async () => {
    
    // Se coloca el valor true para que cuando no hayan valores
    // pase a false y ejecute el watch 
    isDataLength.value      = true;

    // Cuando hace todo el recorrido y no encuentra valores, oculta la vista
    if(ipsArray.value.length === 0){
        store.commit('setVirtualMachine', false);
    }

    // Cuando el array tiene al menos un valor 
    else{
        let ip = ipsArray.value[0];
        finalTableItems.value = [];

        const allData = await getVirMacServerByIP({ip: ip})
    
        isDataLength.value = allData.showGraphs
        if( allData.status === 400 ){
            store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
        }
        if( allData.status === 200 ){
            finalTableItems.value = allData.data
        }
    }
}

/**
 * Cuando ha sido recargada el Dashboard, carga todo el componente de nuevo
 */
watch(isRecharge,(rech) => {
    if(rech){
        ipsArray.value = computeipsArray.value;
        getMVSDialog();
    }
})

/**
 * Cuando "isDataLength" tiene valor: "FALSE",
 * borra el valor utilizado y realiza de nuevo la
 * petición a la API
 */
watch(isDataLength,async (dataLength) => {
    if(!dataLength){
        await ipsArray.value.shift();
        await getMVSDialog();
    }
})


const header = FINAL_HEADERS_TABLE.virmac
const HEADERS_VIRTMACH:Ref<HEADER[]>   = ref(header);

onMounted(() => {
    getMVSDialog();
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (finalTableItems.value.length > 0)
    ? (_openBlock(), _createBlock(_component_EasyDataTable, {
        key: 0,
        "header-text-direction": "center",
        "table-class-name": "customize-table",
        headers: HEADERS_VIRTMACH.value,
        items: finalTableItems.value,
        "rows-per-page": __props.rows
      }, {
        "header-porcCPU": _withCtx((header) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(header.text), 1),
            _createElementVNode("div", null, "(% " + _toDisplayString(_unref(t)('labels.available')) + ")", 1)
          ])
        ]),
        "header-porcMemor": _withCtx((header) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(header.text), 1),
            _createElementVNode("div", null, "(% " + _toDisplayString(_unref(t)('labels.available')) + ")", 1)
          ])
        ]),
        "header-porcDisco": _withCtx((header) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(header.text), 1),
            _createElementVNode("div", null, "(% " + _toDisplayString(_unref(t)('labels.available')) + ")", 1)
          ])
        ]),
        "item-state": _withCtx((item) => [
          _createVNode(_component_v_row, {
            justify: "center",
            class: "ma-0"
          }, {
            default: _withCtx(() => [
              (item.CPUActual === 0)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "red"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" mdi-monitor-screenshot ", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    color: "green"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" mdi-monitor-screenshot ", -1)
                    ]))]),
                    _: 1
                  })),
              (item.CPUActual === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " OFF "))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, " ON "))
            ]),
            _: 2
          }, 1024)
        ]),
        "item-porcDisco": _withCtx((item) => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "text-end pa-0 pr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.dispDisco) + "% ", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_linear, {
                    "model-value": item.porcDisco,
                    height: "10",
                    striped: "",
                    rounded: "",
                    color: 
                item.porcDisco > 80 ? '#FF0000' : item.porcDisco <= 80 && item.porcDisco >= 50 ? '#FFEE00' :'#00FF00'
                  }, null, 8, ["model-value", "color"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        "item-porcCPU": _withCtx((item) => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "5",
                class: "text-end pa-0 pr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.dispCPU) + "% ", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "7",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_linear, {
                    "model-value": item.porcCPU,
                    height: "10",
                    striped: "",
                    rounded: "",
                    color: 
                    item.porcCPU > 80 ? '#FF0000' : item.porcCPU <= 80 && item.porcCPU > 50 ? '#FFEE00' :'#00FF00'
                  }, null, 8, ["model-value", "color"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        "item-porcMemor": _withCtx((item) => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "5",
                class: "text-end pa-0 pr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.dispMemor) + "% ", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "7",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_linear, {
                    "model-value": item.porcMemor,
                    height: "10",
                    striped: "",
                    rounded: "",
                    color: 
                    item.porcMemor > 80 ? '#FF0000' : item.porcMemor <= 80 && item.porcMemor > 50 ? '#FFEE00' :'#00FF00'
                  }, null, 8, ["model-value", "color"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["headers", "items", "rows-per-page"]))
    : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
}
}

})